module.exports = __webpack_public_path__ + "img/1968-Lamborghini-Islero-400GT.d88da646.jpg";